/*
 * @Description:权限相关工具
 * @Author: gonghong
 * @Date: 2024-02-20 09:39:24
 * @LastEditTime: 2024-02-22 15:18:31
 */
import Storage from '@/utils/storage'
import router from '@/router'
import { useSystemStore } from '@/store/modules/system'
/**
 * @description: 判断是否有Authorization，是否已登录
 * @return {*}
 */
export const isAuthValid = () => {
    if (Storage.getLocal('access_token')) {
        return true
    }
    return false
}
/**
 * @function 保存Authorization到sessonStroage
 * @param token
 * @param expires
 */
export const setTokenToStorage = (token, expires) => {
    Storage.setSession('Authorization', token, expires)
    let newExpires=Date.now() + expires * 1000
    Storage.setSession('expiresSec', expires)
    Storage.setSession('AuthorizationExpires', newExpires)
}

export const setTokenToLocal = (token, expires) => {
    Storage.setLocal('Authorization', token, expires)
    let newExpires=Date.now() + expires * 1000
    Storage.setLocal('expiresSec', expires)
    Storage.setLocal('AuthorizationExpires', newExpires)
}
/**
 * @function 保存refresh_token到sessonStroage
 * @param token
 * @param expires
 */
export const setRefreshTokenToLocal = (refresh_token) => {
    Storage.setLocal('refresh_token', refresh_token)
}
/**
 * @description: 获取缓存里得Authorization
 * @return {*}
 */
export const getTokenToStorage = () => Storage.getSession('Authorization')

/**
 * @description: 清空sesson缓存
 * @return {*}
 */
export const clearToken = () => {
    Storage.clearSession()
    Storage.clearLocal()
}
/**
 * @description: 退出登陆清空缓存和store信息
 * @return {*}
 */
export const loginoutClear = () => {
    console.log('清除loginoutClear')
    router.replace({ path: '/login' })
    const { setUserInfo, setUserAvatar, setInfoAccount, setIsRunWorkLink} = useSystemStore()
    // 清除用户信息和缓存
    setUserInfo({})
    setUserAvatar({})
    setInfoAccount({})
    setIsRunWorkLink(false)
    clearToken()
}
